import React, { useState, useEffect } from "react";
import useAuth from "../../hooks/useAuth";
// import { Button, Metric, Flex, Text, BarChart } from '@tremor/react';

//OVAJ BMI CALCULAR SACUVAJ JER CES PO NJEMU PRAVITI OSTALE SLICNE OVOM
let Bmi = ({ tezina, visina }) => {
  const { id } = useAuth();
  // const [weight, setWeight] = useState('');
  // const [height, setHeight] = useState('');
  // const [bmiHistory, setBmiHistory] = useState({
  //   "24/5/2023": 27.4,
  //   "1/8/2023": 21.2,
  //   "3/8/2024": 30.7,
  //   "14/7/2024": 25.1,
  // });
  // const [bmi, setBmi] = useState(null);

  // const calculateBMI = () => {
  //   if (weight && height) {
  //     const heightInMeters = height / 100; // convert cm to meters
  //     const bmiValue = weight / (heightInMeters * heightInMeters);
  //     const date = new Date().toLocaleDateString(); // Get the current date
  //     setBmi(bmiValue);
  //     setBmiHistory(prev => ({ ...prev, [date]: bmiValue }));
  //   }
  // };

  // const getBMIClassification = (bmi) => {
  //   if (bmi < 18.5) return "Underweight";
  //   if (bmi >= 18.5 && bmi < 24.9) return "Normal weight";
  //   if (bmi >= 25 && bmi < 29.9) return "Overweight";
  //   return "Obesity";
  // };

  // const bmiEntries = Object.entries(bmiHistory);

  //   return (
  //     <>
  //       <h2 className="text-2xl font-bold mt-8 mb-4">BMI Istorija</h2>
  //       <table className="min-w-full border-collapse border border-gray-300">
  //         <thead>
  //           <tr>
  //             <th className="border border-gray-300 p-2">Datum</th>
  //             <th className="border border-gray-300 p-2">BMI</th>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           {bmiEntries.map(([date, bmi]) => (
  //             <tr key={date}>
  //               <td className="border border-gray-300 p-2">{date}</td>
  //               <td className="border border-gray-300 p-2">{bmi.toFixed(1)}</td>
  //             </tr>
  //           ))}
  //         </tbody>
  //       </table>
  //       </>
  //   );
  // };
  const [weight, setWeight] = useState(tezina);
  const [height, setHeight] = useState(visina);
  const [bmi, setBmi] = useState(null);

  const calculateBMI = (weight, heightCm) => {
    if (heightCm <= 0) {
      throw new Error("Visina mora da bude vise od 0.");
    }
    const heightM = heightCm / 100;
    return weight / (heightM * heightM);
  };

  const handleCalculate = () => {
    const weightNum = parseFloat(weight);
    const heightNum = parseFloat(height);

    if (
      isNaN(weightNum) ||
      isNaN(heightNum) ||
      weightNum <= 0 ||
      heightNum <= 0
    ) {
      alert("Unesite validnu visinu i težinu.");
      return;
    }

    const bmiValue = calculateBMI(weightNum, heightNum);
    setBmi(bmiValue);
  };

  const bmiCategories = [
    { label: "Neuhranjenost", max: 18.5, color: "bg-green-300" },
    { label: "Normalno", max: 24.9, color: "bg-yellow-300" },
    { label: "Visak kilaze", max: 29.9, color: "bg-orange-300" },
    { label: "Gojaznost", max: Infinity, color: "bg-red-300" },
  ];

  const getGaugeColor = (bmi) => {
    const category = bmiCategories.find((cat) => bmi <= cat.max);
    return category ? category.color : "bg-gray-400";
  };

  //Tabela
  const [bmiHistory1, setBmiHistory1] = useState({
    "24/5/2023": 27.4,
    "1/8/2023": 21.2,
    "3/8/2024": 30.7,
    "14/7/2024": 25.1,
  });

  const bmiEntries = Object.entries(bmiHistory1);

  //Test za slike
  const [imageUrl, setImageUrl] = useState("");

  // Učitaj profilnu sliku korisnika pri učitavanju komponente
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`http://localhost:5000/api/users/${id}`);
        const data = await response.json();
        setImageUrl(`http://localhost:5000${data.imageUrl}`);
      } catch (error) {
        console.error("Greška pri dohvatu profilne slike", error);
      }
    };

    fetchUserData();
  }, [id]);

  // Upload nove profilne slike
  const handleUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await fetch(
        `http://localhost:5000/api/users/${id}/upload`,
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await response.json();
      setImageUrl(`http://localhost:5000${data.imageUrl}`);
      alert("Profilna slika uspešno postavljena!");
    } catch (error) {
      console.error("Greška pri uploadu slike", error);
    }
  };
  return (
    <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md border border-gray-500">
      <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">
        BMI Kalkulator
      </h1>
      <div className="flex space-x-4 mb-4">
        <div className="flex flex-col w-full">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Težina (kg)
          </label>
          <input
            type="number"
            placeholder="Težina (kg)"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            className="border border-gray-300 rounded-lg p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="flex flex-col w-full">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Visina (cm)
          </label>
          <input
            type="number"
            placeholder="Visina (cm)"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
            className="border border-gray-300 rounded-lg p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
      <button
        onClick={handleCalculate}
        className="w-full bg-blue-600 text-white rounded-lg py-3 hover:bg-blue-700 transition duration-300"
      >
        Izracunaj BMI
      </button>

      {bmi !== null && (
        <div className="mt-6 text-center">
          <h2 className="text-2xl font-semibold text-gray-800">
            Tvoj BMI: {bmi.toFixed(2)} kg/m2
          </h2>
          <div className="relative mt-4 w-full h-10 bg-gray-200 rounded-full">
            <div
              className={`absolute top-0 left-0 h-full rounded-full transition-all duration-500 ${getGaugeColor(
                bmi
              )}`}
              style={{ width: `${(bmi / 40) * 100}%` }}
            />
          </div>
          <div className="flex justify-between mt-2 text-sm text-gray-600">
            {bmiCategories.map((category) => (
              <span key={category.label}>{category.label}</span>
            ))}
          </div>
        </div>
      )}
      {/* <div className="flex flex-col items-center gap-4">
        <h2 className="text-xl">Profilna slika</h2>
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="Profilna"
            className="w-32 h-32 rounded-full"
          />
        ) : (
          <div className="w-32 h-32 bg-gray-300 rounded-full"></div>
        )}
        <input
          type="file"
          onChange={handleUpload}
          className="border p-2 rounded"
        />
      </div> */}
    </div>
  );
};

export default Bmi;

{
  /* Tabela */
}

{
  /* <h2 className="text-2xl font-bold mt-8 mb-4">BMI Istorija (samo prikaz)</h2>
<table className="min-w-full border-collapse border border-gray-300">
  <thead>
    <tr>
      <th className="border border-gray-300 p-2">Datum</th>
      <th className="border border-gray-300 p-2">BMI</th>
    </tr>
  </thead>
  <tbody>
    {bmiEntries.map(([date, bmi]) => (
     <tr key={date}>
       <td className="border border-gray-300 p-2">{date}</td>
       <td className="border border-gray-300 p-2">{bmi.toFixed(1)}</td>
     </tr>
   ))}
 </tbody>
</table> */
}
